module.exports = __webpack_public_path__ + "static/media/boat-img-34.00af08d0.jpg";